// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Movement from "./Movement.res.js";
import * as V2$Linear from "lumi-linear/lib/es6/src/V2.res.js";
import * as V2f$Linear from "lumi-linear/lib/es6/src/V2f.res.js";
import * as M23f$Linear from "lumi-linear/lib/es6/src/M23f.res.js";
import * as PointerMove from "./PointerMove.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Transform$Linear from "lumi-linear/lib/es6/src/Transform.res.js";

function addMovement(movement, transform) {
  return Transform$Linear.M23f.addTranslation(transform, Movement.rel(movement));
}

function usePTZ(transform, setTransform, panButton, getPointerPosition) {
  let zoom = (delta, pointer) => {
    let translation = V2f$Linear.multiply(V2$Linear.fill(1 - delta), pointer);
    setTransform(matrix => Transform$Linear.M23f.addTranslation(M23f$Linear.scale(matrix, delta), translation));
  };
  let onPinch = (param, param$1, diff) => {
    let leftPos = getPointerPosition(param[0]);
    let rightPos = getPointerPosition(param[1]);
    let center = V2f$Linear.scale(V2f$Linear.plus(leftPos, rightPos), 0.5);
    zoom(2 ** diff, center);
  };
  let match = PointerMove.use(getPointerPosition, panButton, undefined, undefined, (_event, movement) => setTransform(__x => addMovement(movement, __x)), onPinch, undefined);
  let transform$1 = Stdlib_Option.mapOr(match.pointerMove, transform, __x => addMovement(__x, transform));
  return {
    onKeyDown: e => {
      if (e.key === "Escape") {
        return setTransform(param => Transform$Linear.M23f.identity);
      }
    },
    onPointerDown: match.onPointerDown,
    onPointerMove: match.onPointerMove,
    onPointerUp: match.onPointerUp,
    onPointerLeave: match.onPointerLeave,
    onPointerOut: match.onPointerOut,
    onPointerCancel: match.onPointerCancel,
    onContextMenu: e => {
      e.preventDefault();
    },
    onWheel: e => {
      let pointer = getPointerPosition(e);
      let deltaY = e.deltaY;
      let match = e.deltaMode;
      let delta = match !== 0 ? (
          match !== 1 ? deltaY : deltaY * 0.05
        ) : deltaY * 0.002;
      if (e.shiftKey) {
        return setTransform(matrix => Transform$Linear.M23f.compose(Transform$Linear.M23f.rotationAround(delta, pointer), matrix));
      } else {
        return zoom(2 ** - delta, pointer);
      }
    },
    transform: transform$1
  };
}

export {
  addMovement,
  usePTZ,
}
/* Movement Not a pure module */
